import { useEffect } from "react";
import { useLocation } from "wouter";

export function ScrollToTop() {
  const [pathname] = useLocation();

  useEffect(() => {
    try {
      // 'instant' bypasses CSS smooth scrolling so the user doesn't see
      // a sliding effect while the new page renders.
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant" as ScrollBehavior,
      });
    } catch {
      // Fallback for older browsers that don't support 'instant'
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
}
